<template>
  <div>
    <h3 class="title">{{searching ? 'Search' : `Search Results (${results.length})`}}</h3>
    <ContentSkeleton source="search" v-if="searching" class="mt-4" />

    <div v-if="!searching && results.length">
        <router-link :to="'/circle/' + circle._id" v-for="circle in results" :key="circle._id">
            <div class="content mb-4">
                <div>
                    <div class="content-header">
                        <div class="d-flex align-items-start">
                            <img v-if="circle.upload && circle.upload.path" class="content-header__avatar rounded-circle mt-1" width="40" height="40"
                                :src="circle.upload.path" alt/>
                            <img v-else class="content-header__avatar rounded-circle mt-1" width="40" src="../../../assets/avatar.png" alt />
                            <div class="content-header__description ml-2">
                                <div class="content-header__info">
                                    <span class="content-header__name">{{circle.title}}</span>
                                </div>
                                <div class="content-header__meta">
                                    <span role="role">{{isPublic(circle) ? 'Public' : 'Private'}} Circle</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
    </div>

    <EmptyFeed v-if="!searching && !results.length" emptyFeedFor="search" :altText="emptyText"/>
  </div>
</template>

<script>
    import CircleService from "@/services/circle";
    import ContentSkeleton from "../ContentSkeleton/ContentSkeleton.vue";
    import EmptyFeed from "../EmptyFeed/EmptyFeed.vue";

    const circleService = new CircleService();

    export default {
        name: "CircleSearch",
        props: ["query"],
        components: { ContentSkeleton, EmptyFeed },
        data() {
            return {
                searching: true,
                results: []
            }
        },
        computed: {
            emptyText: function() {
                return `No results were found for the keyword "${this.$props.query}"`;
            }
        },
        methods: {
            isPublic(circle) {
                return circle.flags ? (circle.flags.findIndex(flag => flag.type.toLowerCase() === "visibility").value.toLowerCase() === "public" > -1) : true;
            }
        },
        watch: {
            "$props.query": {
                handler: async function(val) {
                    if (val) {
                        this.searching = true;

                        try {
                            this.results = await circleService.searchCircles(val);
                            this.searching = false;
                        } catch (err) {
                            (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
                            (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
                        }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
<style lang="scss" scoped src="../CircleSettings/CircleSettings.scss"></style>
<style lang="scss" scoped src="../FeedContent/FeedContent.scss"></style>